var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "v-app",
        [
          _c("v-main", [_c("router-view")], 1),
          _c(
            "v-snackbar",
            {
              attrs: { timeout: -1, color: "accent", rounded: "pill" },
              scopedSlots: _vm._u([
                {
                  key: "action",
                  fn: function (ref) {
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._b(
                          {
                            attrs: { text: "", color: "primary" },
                            on: { click: _vm.reloadUpdateApp },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        [_vm._v(_vm._s(_vm.appResource.update))]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.appUpdateExists,
                callback: function ($$v) {
                  _vm.appUpdateExists = $$v
                },
                expression: "appUpdateExists",
              },
            },
            [_vm._v(_vm._s(_vm.appResource.appUpdateAvailable))]
          ),
          _vm.isNpe
            ? _c(
                "v-snackbar",
                {
                  staticStyle: { "white-space": "pre" },
                  attrs: {
                    timeout: -1,
                    color: "red",
                    centered: "",
                    "min-width": "33%",
                    "min-height": "66%",
                  },
                  model: {
                    value: _vm.noNpeAccess,
                    callback: function ($$v) {
                      _vm.noNpeAccess = $$v
                    },
                    expression: "noNpeAccess",
                  },
                },
                [_vm._v(_vm._s(_vm.appResource.noNpeAccess))]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }